import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { EmptyState, PageSkeleton } from "@/components/ui";
import { BulkEditRunsPage } from "@/components/bulk-edits/home/bulk-edit-runs-page";
import { usePermissions } from "@/hooks/use-permissions";

export const Route = createFileRoute("/_authenticated/bulk-edits/")({
  component: BulkEditsRoute,
});

/**
 * `/bulk-edits`, the Bulk Editor's home: the org's runs, gated on
 * `bulk_edits:read`. While the envelope loads the page is a skeleton, never
 * the denied state.
 */
function BulkEditsRoute() {
  const { t } = useTranslation("bulkEdits");
  const navigate = useNavigate();
  const { can, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <div className="p-4 sm:p-8">
        <PageSkeleton />
      </div>
    );
  }
  if (!can("bulk_edits", "read")) {
    return (
      <div className="p-4 sm:p-8">
        <EmptyState
          title={t("denied.read.title")}
          description={t("denied.read.body")}
          variant="inline"
        />
      </div>
    );
  }

  return (
    <BulkEditRunsPage
      onOpenRun={(runId) => void navigate({ to: "/bulk-edits/$runId", params: { runId } })}
      onNewRun={() => void navigate({ to: "/bulk-edits/new" })}
    />
  );
}
